import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("be37f31c1e", "._11fc52b637ff8a7e__slot{inset:0;isolation:isolate;pointer-events:none;position:fixed;z-index:1000000003}@layer wp-ui{@layer utilities, components, compositions, overrides;@layer utilities{._11fc52b637ff8a7e__slot>*{pointer-events:auto}}}");
}
export default {"slot":"_11fc52b637ff8a7e__slot"};
